export class AmountType {
    id: number;
    name: string;
}
